import ADPTntService from "../../../services/admin/ADPTntService";
import GEOCtryService from "../../../services/geo/GEOCtryService";
import GEODistService from "../../../services/geo/GEODistService";
import GEOPostService from "../../../services/geo/GEOPostService";
import GEOStateService from "../../../services/geo/GEOStateService";

class tenantService {
    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async create(data: any): Promise<any> {
        return await ADPTntService.create(data);
    }

    async update(id: string, data: any): Promise<any> {
        return await ADPTntService.update(id, data);
    }
    
    async findAllTenant(): Promise<any> {
        return await ADPTntService.findAll();
    }

    async getStateDropdown(countryCode: any): Promise<any> {
        return await GEOStateService.getDropdownByCountryCode(countryCode);
    }

    async getCountryDropdown(): Promise<any> {
        return await GEOCtryService.getCountryDropdown();
    }

    async getDistrictDropdown(stateCode: string): Promise<any> {
        return await GEODistService.getDropdownByCountryCodeAndStateCode('MYS',stateCode);
    }

    async getPostcodeDropdown(stateCode: string): Promise<any> {
        return await GEOPostService.getDropdownByStateCode(stateCode);
    }

    async getFacilityDropdown(facilityCode: any): Promise<any> {
        return await ADPTntService.getItemsExcludeFacilityCode(facilityCode);
    }
    
}

export default new tenantService();